const LOCAL_STORAGE = {
  name_cookie_token: 'pharmedistore_token',
}

export default LOCAL_STORAGE
